import useSWR from 'swr';
import { CACHE_KEYS } from '@/constants/cache-keys';
import { EngineService } from '@/services/engine/engine-service';
import type { SystemVersion } from '@/types/system';

export function useAppVersion() {
    const { data, isLoading, error } = useSWR<SystemVersion>(
        CACHE_KEYS.SYSTEM_VERSION,
        () => EngineService.getSystemVersion(),
        {
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            revalidateIfStale: false,
        },
    );

    return { systemVersion: data, isLoading, error };
}
